import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/rootReducer';
import CommonVideo from '../../../../common/CommonVideo';
import Loader from '../../../../common/Loader';
const Webinars: React.FC = () => {
    const webinars = useSelector((state: RootState) => state.deal.webinars);
    const loading = useSelector((state: RootState) => state.deal.webinarLoading);

    return (
        <>
            {loading && (
                <div className="flex justify-center">
                    <Loader />
                </div>
            )}
            {!loading && (
                <div className={webinars.length ? 'block overflow-y-auto' : 'hidden'}>
                    {webinars.map((w, index) => (
                        <div key={`webianr_${index}`} className={`${index === webinars.length - 1 ? '' : 'mb-4'}`}>
                            <div className=" overflow-hidden bg-[#F1F7FF] relative m-auto md:ml-4">
                                <div className="w-full m-auto relative">
                                    {/* <div className="absolute right-4 top-2 z-[5] text-center bg-[#DAFEE9] px-2 py-0.5">
                                    <span className="text-[#13974B] font-[WorkSans-Semibold] font-bold text-sm">
                                        Webinar
                                    </span>
                                </div> */}
                                    <CommonVideo url={w.url} title="" />
                                </div>
                                <div className="px-6 py-4">
                                    <div>
                                        <label className="text-xs text-[#27AE60] font-[WorkSans]">
                                            {w.date && w.date.date}
                                        </label>
                                    </div>
                                    <p className="text-lg font-[WorkSans-Bold] font-bold text-[#0F2240] uppercase">
                                        {w.title}
                                        {w.title && (
                                            <span style={{ textTransform: 'none' }}>
                                                &nbsp;-&nbsp; Webinar {w.date && moment(w.date.date).format('DD.MM.YY')}
                                            </span>
                                        )}
                                    </p>
                                    <p className="text-sm text-[#000000] font-[Lato] pt-3">{w.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default Webinars;
